import { render, staticRenderFns } from "./TripsPanel.vue?vue&type=template&id=4062dc6d"
import script from "./TripsPanel.vue?vue&type=script&lang=js"
export * from "./TripsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports